import { PageRef } from 'providers/page-ref';
import { ErrandAnswerShape } from 'pages/foods/add-food-errand';

export type LabelScannerPageParams = {
  /**
   * The add-food errand (`pages/foods/add-food-errand.ts`): handed on to the food editor this
   * page replaces itself with, NOT acted on by this page (#4968, #5377).
   *
   * This scanner never answers anybody itself: it swaps itself for the food editor, which is
   * what eventually closes and finishes the errand with the food that was made. So all of it is
   * carried through rather than used here. Passing it is what lets the user's errand -- adding
   * the food to a meal, or logging it to a day -- carry on, instead of ending at a saved food
   * nobody asked for.
   */
  returnCallback?: string;
  errandAnswerShape?: ErrandAnswerShape;
  gotoLogFoodAfterSelect_dayDate?: string;
  /**
   * The barcode the user scanned a moment ago, when scanning it found no food and they chose to
   * scan the label instead. The new food should end up carrying it, so that the same product is
   * found by barcode next time. It is reconciled against any barcode the label scan itself
   * reads off the package by the food editor, which is the only place that can see both.
   */
  ean?: string;
  local?: {
    // carried through to the food editor beside returnCallback -- see above
    returnContext?: unknown;
  };
};

export type LabelScannerPageResult = void;

export const ILabelScannerPage: PageRef<LabelScannerPageParams, LabelScannerPageResult> = {
  pageName: 'LabelScannerPage',
} as PageRef<LabelScannerPageParams, LabelScannerPageResult>;
